<template>
  <div id="MSfooter">
    <!-- <span>北京元智东方科技有限公司 版权所有 智能VLOG
      <br />京ICP备18055032号-1</span> -->
  </div>
</template>

<script>
export default {
  name: "MSfooter",
};
</script>
<style lang='scss' scoped>
#MSfooter {
  @extend .flex;
  height: 80px;
  text-align: center;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue